import React from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';

const Unauthorized = () => {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--bg-page)' }}>
      <div className="text-center max-w-md p-8">
        <AlertTriangle size={64} className="mx-auto mb-4" style={{ color: '#DC2626' }} />
        <h1 className="heading-1 mb-4">Access Denied</h1>
        <p className="body-large mb-6" style={{ color: 'var(--text-secondary)' }}>
          You don't have permission to access this page.
        </p>
        <div className="flex gap-4 justify-center">
          <Link to="/" className="btn-primary">
            Go Home
          </Link>
          <Link to="/login" className="btn-secondary">
            Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;